/* Runental: kleine Komfort-Skripte, 20.10.2026 */

/* 1) Collection-Beschreibung auf dem Handy einklappen */
(function () {
  var MQ = window.matchMedia('(max-width: 768px)');

  function init() {
    if (!MQ.matches) return;
    var els = document.querySelectorAll('.collection__description');
    for (var i = 0; i < els.length; i++) {
      setup(els[i]);
    }
  }

  function setup(el) {
    if (el.getAttribute('data-rt-collapse')) return;
    el.setAttribute('data-rt-collapse', '1');
    var fs = parseFloat(window.getComputedStyle(el).fontSize) || 16;
    if (el.scrollHeight <= fs * 14) return;

    el.classList.add('rt-collapsed');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rt-readmore';
    btn.textContent = 'Weiterlesen';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var collapsed = el.classList.toggle('rt-collapsed');
      btn.textContent = collapsed ? 'Weiterlesen' : 'Weniger anzeigen';
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      if (collapsed) {
        el.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });
    el.parentNode.insertBefore(btn, el.nextSibling);
  }

  function start() {
    init();
    var root = document.getElementById('CollectionAjaxContent');
    if (root && window.MutationObserver) {
      new MutationObserver(init).observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* 2) Footer-Links statt schwebender Symbole:
      Cookie-Einstellungen (Pandectes, Symbol ueberall aus)
      Barrierefreiheit (SEA Accessibility, Symbol nur auf dem Handy aus, per CSS) */
(function () {
  function getCookieWidget() {
    var host = document.querySelector('pandectes-cmp');
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('button.widget');
  }

  function hideCookieWidget() {
    var btn = getCookieWidget();
    if (btn) btn.style.setProperty('display', 'none', 'important');
    return !!btn;
  }

  function openCookieSettings(e) {
    if (e) e.preventDefault();
    var btn = getCookieWidget();
    if (btn) {
      btn.click();
    } else {
      window.location.href = '/pages/cookies';
    }
  }

  function openAccessibility(e) {
    if (e) e.preventDefault();
    var w = document.getElementById('Sea-Accessibility__ButtonWidget');
    if (w) w.click();
  }

  function addFooterLink(afterRef, cls, href, text, handler) {
    if (document.querySelector('.' + cls)) return afterRef;
    if (!afterRef) return null;
    var refItem = afterRef.closest('li');
    var a = document.createElement('a');
    a.href = href;
    a.className = (afterRef.className || '').replace(/\brt-[\w-]+/g, '').trim() + ' ' + cls;
    a.textContent = text;
    a.addEventListener('click', handler);
    if (refItem) {
      var li = document.createElement('li');
      li.className = refItem.className;
      li.appendChild(a);
      refItem.parentNode.insertBefore(li, refItem.nextSibling);
    } else {
      afterRef.parentNode.insertBefore(a, afterRef.nextSibling);
    }
    return a;
  }

  function addFooterLinks() {
    var ref = document.querySelector('.site-footer__linklist a[href="/pages/cookies"]');
    var cookieLink = document.querySelector('.site-footer__linklist a[href="#reopenBanner"]') || ref; /* Cookie-Einstellungen kommt seit 21.10.2026 als Menuepunkt (#reopenBanner, Pandectes) */
    addFooterLink(cookieLink, 'rt-accessibility', '#barrierefreiheit', 'Barrierefreiheit', openAccessibility);
  }

  function start() {
    addFooterLinks();
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var host = document.querySelector('pandectes-cmp');
      if (hideCookieWidget()) {
        clearInterval(timer);
        if (window.MutationObserver && host && host.shadowRoot) {
          new MutationObserver(hideCookieWidget).observe(host.shadowRoot, { childList: true, subtree: true });
        }
      } else if (tries > 60) {
        clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
